exports.default = {
  'paiteams': 'PAITEAMS',
  'discover': 'Discover',
  'home': 'Home',
  'conversation': 'Chats',
  'projects': 'Projects',
  'assets': 'Assets',
  'account_settings': 'Account Settings',
  'my_sub': 'My subscriptions',
  'upgrade': 'Upgrade',
  'upgrade_to_pro': 'Upgrade to Pro',
  'language': 'Language',
  'theme': 'Theme',
  'logout': 'Logout',
  'team_invitation': 'Team Invitation',
  'confirm': 'Confirm',
  'create_team': 'Create Team',
  'cancel': 'Cancel',
  'join_team': 'Join Team',
  'leave_team': 'Leave Team',
  'confirm_leave_team': 'Leave this team? You will no longer be able to access its resources.',
  'leave_team_success': 'You left the team',
  'confirm_logout': 'Are you sure you want to log out of the system?',
  'logout_system': 'Logout System',
  'exit': 'Exit',
  'return_to_agentstore': 'Return to AgentStore',
  'exit_management': 'Exit management',
  'team_management': 'Team Management',
  'organization_info': 'Organization',
  'member_management': 'Member Management',
  'team_settings': 'Team Settings',
  'member_department': 'Members & Departments',
  'member_approval': 'Member Approval',
  'role_management': 'Role Management',
  'limit_management': 'Limit Management',
  'consumption_records': 'Consumption Records',
  'no_management_permission': 'You do not have management permissions!',
  'current_team': 'Current team',
  'personal_team': 'Personal team',
  'enterprise_team': 'Enterprise team',
  'available_points': 'Available credits',
  'light': 'Light',
  'dark': 'Dark',
  'system': 'System',
  'invite_reward': 'Invite Rewards',
  'invite_reward_tip': 'Invite friends to earn free credits',
  'refer_friend': 'Refer a Friend',
  'bind_invite_code': 'Enter Invite Code',
  'free_credits': 'Free Credits',
  'contact_us': 'Contact us',
  'enterprise_contact': 'WeCom contact',
  'enterprise_dialog_heading': 'Create together, stay organized',
  'enterprise_dialog_intro': 'Bring team collaboration, assets, and member management into one clear workflow.',
  'enterprise_benefit_collaboration': 'Team collaboration',
  'enterprise_benefit_collaboration_desc': 'Keep creative work aligned and reduce handoff overhead.',
  'enterprise_benefit_brand': 'Brand standards',
  'enterprise_benefit_brand_desc': 'Manage brand assets and usage standards in one place.',
  'enterprise_benefit_assets': 'Asset management',
  'enterprise_benefit_assets_desc': 'Organize team assets for faster discovery and reuse.',
  'enterprise_benefit_flexible': 'Flexible setup',
  'enterprise_benefit_flexible_desc': 'Configure usage and service benefits for your team size.',
  'enterprise_benefit_members': 'Member management',
  'enterprise_benefit_members_desc': 'Manage team members and workspaces consistently.',
  'enterprise_benefit_service': 'Dedicated support',
  'enterprise_benefit_service_desc': 'Get guidance on a plan that fits your organization.',
  'enterprise_service_custom': 'Benefits tailored to you',
  'enterprise_service_scale': 'Scales with your team',
  'enterprise_service_advisor': 'Dedicated advisory service',
  'enterprise_advisor_title': 'Talk to an enterprise advisor',
  'enterprise_advisor_desc': 'Tell us about your team size and needs, and we will help you find the right enterprise plan.',
  'enterprise_qrcode_placeholder': 'WeCom QR code coming soon',
  'enterprise_qrcode_hint': 'The QR code will appear here once confirmed'
}
